// https://github.com/w3c/IntersectionObserver/tree/master/polyfill
import 'intersection-observer'; // IE-11 PolyFill
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  // https://lobotuerto.com/vuetify-color-theme-builder/
  theme: {
    options: { // MLD-5135 @see https://stackoverflow.com/questions/50243769/vuetify-how-to-set-background-color
      customProperties: true, // @see https://v2.vuetifyjs.com/en/features/theme/#custom-properties
    },
    dark: false,
    themes: { // @see https://v2.vuetifyjs.com/en/features/theme/
      /*dark: {},*/
      // @see https://paletton.com/#uid=13R0u0koZ9qfJg2k+d8tD5QDU2J
      light: {
        //primary: '#398bf7',
        //primary: '#0a3c87',
        bars: '#205EAF',
        primary: '#184784',
        secondary: '#072a5f',
        accent: '#FF9800',
        background: '#F6F5F4', // MLD-5135 @see https://stackoverflow.com/questions/50243769/vuetify-how-to-set-background-color
      }
    }
  }
});
